import {Component, HostBinding, OnDestroy, OnInit} from '@angular/core';
import {routeAnimation} from '../../../../route.animation';
import {FormBuilder, Validators} from '@angular/forms';
import {FormsService} from '../../../../_services/forms.service';
import {Subscription} from 'rxjs/Subscription';
import {PreviousUrlService} from '../../../../_services/previous-url.service';
import {ReportsService} from '../../../../_services/reports.service';
import {ActivatedRoute, Params} from '@angular/router';
import {ReportsBuildings} from '../../../../_interfaces/reports/reports-buildings';
import {ApiService} from '../../../../_interceptors/api.service';
import {Reports} from '../../../../_interfaces/reports/reports';
import {PageTitleService} from '../../../../_services/page-title.service';
import {environment} from '../../../../../environments/environment';

@Component({
	selector: 'app-reports-buildings-edit',
	templateUrl: './reports-buildings-edit.component.html',
	styleUrls: ['./reports-buildings-edit.component.scss'],
	animations: [routeAnimation]
})

export class ReportsBuildingsEditComponent implements OnInit, OnDestroy {

	@HostBinding('@routeAnimation') routerTransition = true;

	public report_id: number = null;
	public building_id: number = null;

	public reportsBuildingEditForm = this.formBuilder.group({
		name: ['', [Validators.required, Validators.maxLength(50)]],
		description: [''],
		query: ['']
	});

	private _activatedRouteSubscription: Subscription = null;
	private _errorsSubscription: Subscription = null;

	constructor(public reportsService: ReportsService,
				private apiService: ApiService,
				public formsService: FormsService,
				private previousUrlService: PreviousUrlService,
				private activatedRoute: ActivatedRoute,
				private formBuilder: FormBuilder,
				private pageTitleService: PageTitleService) {
	}

	ngOnInit(): void {
		this.formsService.form = this.reportsBuildingEditForm;

		this._activatedRouteSubscription = this.activatedRoute.params.subscribe((params: Params) => {
			this.report_id = parseInt(params['report_id'], 10);
			this.building_id = parseInt(params['building_id'], 10);

			this.reportsService.getReport(this.report_id).then((report: Reports) => {
				if (typeof report !== 'undefined') {

					this.pageTitleService.setTitle(report.report_nr + ' | Edit report building | ' + environment.webappName);
					this.pageTitleService.setPageTitle(report.report_nr);
				}
			});

			this.previousUrlService.setPreviousUrlIfNull('/reports/' + this.report_id + '/buildings');

			this.reportsService.getBuilding(this.report_id, this.building_id).then((data2: ReportsBuildings) => {
				if (typeof data2 !== 'undefined') {
					this.formsService.populateForm(data2);
				}
			});
		});

		this._errorsSubscription = this.reportsService.errors.subscribe(errors => {
			this.formsService.processErrors(errors);
		});
	}

	ngOnDestroy(): void {
		if (this._activatedRouteSubscription !== null) {
			this._activatedRouteSubscription.unsubscribe();
		}

		if (this._errorsSubscription !== null) {
			this._errorsSubscription.unsubscribe();
		}
	}
}
